import { Entry } from './entry';

Entry.displayName = 'SegmetedControlIndicator';

export { Entry as Indicator };
